import { createContext } from 'react';

/** Global chrome shared by every view's top bar (collapse toggle, alert badge). */
export interface ShellContextValue {
  toggleCollapse: () => void;
  alertCount: number;
}

export const ShellContext = createContext<ShellContextValue>({
  toggleCollapse: () => {},
  alertCount: 0,
});
